// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1816":"6be047972552748d","2235":"e1ce0cc1f537d6ff","3465":"029a6903953f42f8","3782":"cfcbc36b5a22dfb0","5085":"b6f76535b94b0686","5724":"807c5e7bf1cbe3bd","8385":"3825cf391941bf2a"}[chunkId] + ".js";
};